/**
 * 畫面上的金額一律顯示成整數(REQ-20260814003)。
 *
 * 這裡只負責「DECIMAL 字串 → 畫面文字」這一層。後端的金額仍是 DECIMAL(14,2),
 * 電子發票 / 稅務相關的數字也仍以那個精度傳輸與申報 —— **不要**把這個四捨五入
 * 的想法往回帶到 `packages/shared` 的算式或 api 的任何 service。
 */
export function formatMoney(v: string | number | null | undefined): string {
  if (v === null || v === undefined || v === '') return '—';
  const n = Number(v);
  // 不是數字就原樣顯示(沿用各呼叫點原本的退路),不要印出 "NaN"
  if (!Number.isFinite(n)) return String(v);
  const rounded = Math.round(n);
  // Math.round(-0.2) 是 -0,直接 toLocaleString 會印出「-0」(對帳單上的負餘額尾數會踩到)
  return (rounded === 0 ? 0 : rounded).toLocaleString('zh-TW', { maximumFractionDigits: 0 });
}
